/**
 * @Description: 标签边框信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https, { axiosHttpPost } from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  LabelFrameModel,
  LabelFrameViewModel,
  LabelFrameSearchModel,
  LabelFramePageSearchModel,
  // LabelFrameAddModel,
  LabelFrameUpdateModel,
  IdsModel
} from '@/model/product/LabelFrameModel'

const baseUrl = Route.product + '/labelFrame'

/**
 * 搜索分页数据
 */
export const pageSearchLabelFrame = (param: LabelFramePageSearchModel) => {
  return https().request<RootObject<PageRespModel<LabelFrameViewModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchLabelFrame = (param: LabelFrameSearchModel) => {
  return https().request<RootObject<LabelFrameModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getLabelFrame = (id: number) => {
  return https().request<RootObject<LabelFrameModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addLabelFrame = (param: FormData) => {
  return axiosHttpPost(baseUrl.concat('/add'), param, ContentType.multipart)
  // return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.multipart)
}

/**
 * 更新数据
 */
export const updateLabelFrame = (param: LabelFrameUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeLabelFrame = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveLabelFrame = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
